import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Uploader,Button,Toast } from 'vant';
import 'vant/lib/index.css';

Vue.use(Uploader);
Vue.use(Button);
Vue.use(Toast);
Vue.prototype.$toast = Toast
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
